import React, {useEffect, useState} from 'react';
import { listRequests } from '../../lib/apiClient'
import SessionStore from '../../stores/SessionStore';
import store from '../../stores';
import RequestTableRow from './Row';
import Card from 'react-bootstrap/Card';

const RelatedRequestsTab = (props) => {
  const [relatedRequests, setRelatedRequests] = useState([]);


  useEffect(() => {   
    // only run this if the contextSid is not null, otherwise there is no point to run this...
    if(props.request.contextSid){
      getRelated();
    }    
  // eslint-disable-next-line
  }, []);


  async function getRelated(params) {
    let options = {};
    
    options.criteria = encodeURIComponent(`context_sid == ${props.request.contextSid}`);

    const related = await listRequests(SessionStore.accountSid, props.request.bucketSid, props.request.environmentSid, options);
    
    setRelatedRequests(related.data.records);

    if(related.data.records.length > 0){
      props.setRelatedRequestCount(related.data.records.length-1);
    }
  }

  return (
    <>
      {relatedRequests.length > 1 ? 
        (
          <Card bg='light'>
            <Card.Body>
              <Card.Subtitle className="mb-2">{props.request.direction === 'in' ? 'Outbound Requests' : 'Parent Request'}</Card.Subtitle>
              <Card.Text>
                {relatedRequests.map((request) => (
                <>
                  {request.sid !== props.request.sid && <RequestTableRow key={request.sid} request={request} store={store} fromRelated={true} />}
                </>
                ))} 
              </Card.Text>
            </Card.Body>
          </Card>
        ) : (
          <div className="alert alert-secondary" role="alert">
            This request has no related requests.
          </div>
        )  
    }
      
      
    </>      
  );
}

export default RelatedRequestsTab;

